import React from 'react'

import FooterLogo from 'images/inline/footer-logo.svg'

import './CompanyInfoSection.scss'

const companyInfo = {
  name: 'Breaktime Media MWH LLC',
  email: 'support@dailybreak.com',
  email_cta: 'http://support.dailybreak.com/customer/portal/emails/new',
  address: '303 Wyman Street, Suite 300',
  address2: 'Waltham, MA 02451',
}

const CompanyInfoSection = () => (
  <div className="footer__logo">
    <FooterLogo />

    <div className="footer__name">{companyInfo.name} </div>
    <address className="address">
      {companyInfo.address} <br />
      {companyInfo.address2}
    </address>
  </div>
)

export default CompanyInfoSection
